import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

const NewsletterForm = () => {
  const [email, setEmail] = useState('');
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error('Please enter your email');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error('Please enter a valid email address');
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/user/newsletter`, { email });
      toast.success('Subscribed successfully!');
      setEmail('');
    } catch (err) {
      console.error(err);
      const msg = err.response?.data?.error || 'Something went wrong.';
      toast.error(msg);
    }
  };

  return (
    <div className="md:col-span-1 text-center md:text-left flex flex-col items-center md:items-start gap-4">
      <h3 className="text-lg text-gray-800 font-weight:700 mb-2">
        {t('footer.stayUpdated') || 'Stay Updated'}
      </h3>
      <p className="text-sm text-gray-600 mb-4">
        {t('footer.newsletterHint') || 'Subscribe to get price drops & deals'}
      </p>

      <form onSubmit={handleSubmit} className="flex flex-col md:flex-row items-center gap-2 w-full md:w-auto">
        <input
          type="email"
          placeholder={t('footer.emailPlaceholder') || 'Enter your email'}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="rounded-xl input input-bordered w-full md:w-64 text-sm mb-2 md:mb-0 focus:outline-none focus:ring-1 focus:ring-[#FF9900] focus:border-[#FF9900] dark:text-white dark:bg-slate-600"
        />
        <button
          type="submit"
          className="btn bg-primary text-white hover:bg-[rgb(62,43,205)] text-sm w-full md:w-auto rounded-xl"
        >
          {t('footer.subscribe') || 'Subscribe'}
        </button>
      </form>
    </div>
  );
};

export default NewsletterForm;

